// Contains code for Stripe payments that is shared between the Donate Form, Ticketing Form and the 3D secure verification process for repeat donations. 

'use strict';

import loadStripe from 'Scripts/common/load-stripe';
import createFormData from 'Scripts/common/create-form-data';
import fetchJson from 'Scripts/common/fetch-json';

export default class StripeUtils {
	constructor(options) {
		this.isRepeat = options.isRepeat ? true : false;
		this.onSuccess = options.onSuccess;
		this.onFail = options.onFail
		this.confirmEndpoint = options.confirmEndpoint ? options.confirmEndpoint : "/donate/confirm";
	}
	
	// Stripe's JS is loading asyncronously so that it doesn't delay our own scripts from starting
	// Once Stripe is actually needed, we check it's loaded and return a promise
	async loadStripe() {
		const apiKey = $(document.body).data('stripeApiKey');
		console.log("StripeUtils.loadStripe", "Load Stripe", apiKey);
		this.stripe = await loadStripe(apiKey);
		console.log("StripeUtils.loadStripe", "Stripe loaded", this.stripe);
		return this.stripe;
	}

	// Confirm payment function, this follows the Stripe code example by calling itself
	async verify(response) {
		console.log("StripeUtils.verify()", response);

		if(!response.success) {
			this.onFail(response);

		} else if (response.requiresAction) {
			console.log("StripeUtils.verify()", "3D secure needed", {"paymentIntentClientSecret":response.paymentIntentClientSecret})

			// 3D secure authorisation required. Call Stripe's handleCardAction method, this will show a confirm modal.
			const cardActionResult = await this.stripe.handleCardAction(response.paymentIntentClientSecret);

			console.log("StripeUtils.verify()", "stripe.handleCardAction", cardActionResult);

			if (cardActionResult.error) { 
				this.onFail(response);

			} else {
				console.log("StripeUtils.verify()", "stripe.handleCardAction", "3D secure action passed");

				const { success, result } = await fetchJson(this.confirmEndpoint, {
					method: 'POST',
					body: createFormData({
						paymentIntentId: cardActionResult.paymentIntent.id,
						isRepeat: this.isRepeat
					})
				});

				if(!success) {
					console.log("NO SUCESS", result);
					this.onFail(result);
					return;
				}

				console.log("StripeUtils.verify()", "stripe.handleCardAction", "Verification complete", result);

				// Self call to validate the response. It might end up showing the 3D secure form again
				this.verify(result)
			}

		} else {
			this.onSuccess();
		}

		return response;
	}
}